export default __webpack_public_path__ + "static/media/personalized-experience.5b315112.webp";